import { initializeConfig } from "@stringf/services/api";
import * as Sentry from "@sentry/react";

initializeConfig((key) => {
  const mappings = {
    BASE_API_URL: import.meta.env.VITE_BASE_API_URL,
    BASE_LOCAL_API_URL: import.meta.env.VITE_BASE_LOCAL_API_URL,
  };
  return mappings[key];
});

const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    tracesSampleRate: 0.1,
    _experiments: {
      profilesSampleRate: 0.1,
    },
  });
}
